import {useEffect, useState} from 'react';
import Axios from 'axios';
import usePrevious from "./usePrevious";
import {getApiHost} from "../index";


const isEqualSet = (v1, v2) => {
  const set1 = new Set(v1);
  const set2 = new Set(v2);
  const diff_set = new Set([...set1].filter(v => !set2.has(v)));
  return (set1.size === set2.size) && (diff_set.size === 0);
};


const useAxiosGet = () => {
    const [responseList, setResponseList] = useState([]);
    const [requestUrlList, setRequestUrlList] = useState(null);
    const previousRequestUrlList = usePrevious(requestUrlList);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
      const fetchData = async () => {
        setIsError(false);
        setIsLoading(true);
        setResponseList([]);

        Axios.all(
          requestUrlList.map(url => {
            if ( url.startsWith("http://") || url.startsWith("https://") )
              return url;
            return getApiHost() + url;
          }).map(requestUrl => Axios.get(requestUrl))
        ).then(Axios.spread((...responseList) => {
            setResponseList(responseList.map(({ data }) => data));
        })).catch(error => {
            setIsError(true);
        }).finally(() => {
            setIsLoading(false);
        });
      };

      if ( requestUrlList !== null ) {
        if ( ! isEqualSet(requestUrlList, previousRequestUrlList) ) {
          fetchData();
        }
      }
    }, [requestUrlList, previousRequestUrlList]);

    return { isLoading, isError, responseList, setRequestUrlList};
};


export default useAxiosGet;
